export default {
  form: {
    bank_account_number: {
      label: 'Número de conta',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Número de encaminhamento',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'País',
      placeholder: 'Alemanha',
    },
    bank_statement_descriptor: {
      label: 'Descritor de extrato',
      placeholder: 'Nome do restaurante',
      tooltip: 'Este nome será mostrado nos extratos bancários dos clientes',
    },
  },
  buttons: {
    next: 'Seguinte',
    back: 'Anterior',
    use_test_data: 'Usar dados de teste',
  },
  test_data_hint: 'Conta bancária de teste aceite pelo {{gateways}}',
  read_only_warning:
    'As informações bancárias só podem ser alteradas pela nossa equipa. Se precisar de as atualizar, contacte o suporte.',
};
